import { JSX } from "react";

import ErrorIcon from "@mui/icons-material/Error";
import {
  Chip,
  ChipOwnProps,
  SxProps,
  Tooltip,
  TooltipProps,
  Typography,
} from "@mui/material";

const ErrorChip = ({
  sx,
  size = "medium",
  info,
  icon,
  label,
  color = "error",
  variant = "outlined",
  placement = "bottom",
  hideIcon,
  onClose,
}: {
  sx?: SxProps;
  icon?: JSX.Element;
  size?: ChipOwnProps["size"];
  info?: string | number | null;
  label?: string | JSX.Element;
  color?: ChipOwnProps["color"];
  variant?: ChipOwnProps["variant"];
  placement?: TooltipProps["placement"];
  hideIcon?: boolean;
  onClose?: () => void;
}) => (
  <Tooltip
    title={
      <Typography fontSize={11} sx={{ whiteSpace: "pre-line" }}>
        {info}
      </Typography>
    }
    placement={placement}
    sx={sx}
  >
    {label ? (
      <Chip
        size={size}
        color={color}
        label={label}
        variant={variant}
        icon={hideIcon ? <></> : icon || <ErrorIcon />}
        onDelete={onClose}
      />
    ) : (
      icon || <ErrorIcon color="error" />
    )}
  </Tooltip>
);

export default ErrorChip;
